module.exports = __webpack_public_path__ + "static/media/pdp-dark.396a1e40.png";